import { internal } from '../../vendor/elix.js';

function PlaceholderMixin(Base) {

  return class Placeholder extends Base {

    static get observedAttributes() {
      return [
        ...super.observedAttributes,
        'placeholder'
      ];
    }

    get [internal.defaultState]() {
      return Object.assign(
        {},
        super[internal.defaultState],
        { placeholder: '' }
      );
    }

    attributeChangedCallback(attributeName, oldValue, newValue) {
      super.attributeChangedCallback(attributeName, oldValue, newValue);
      if (attributeName === 'placeholder') {
        this.placeholder = newValue;
      }
    }

    get placeholder() {
      return this[internal.state].placeholder;
    }

    set placeholder(placeholder) {
      this[internal.setState]({ placeholder });
    }

    [internal.render](changed) {

      super[internal.render](changed);

      if (changed.placeholder) {
        this.renderPlaceholder();
      }

    }

    renderPlaceholder() {
      const inner = this.shadowRoot.querySelector(this.innerSelector || '#inner');
      if (inner) {
        inner.placeholder = this.placeholder || '';
      }
    }

  }
}

export default PlaceholderMixin;
